module.exports = __webpack_public_path__ + "static/media/11.82d25d70.jpg";